import { actions, createActionTypes, api } from '../../utils/api';

const NAMESPACE = 'GET_FAILURE_DEVICES';
const TYPES = createActionTypes(NAMESPACE);

const action = (mac) => (dispatch) =>
  dispatch(actions.callAPI(NAMESPACE, api.device.getFailure(mac)));

export default { action, TYPES };
